import React from 'react';
import ApprovalsByRole from '../ApprovalsByRole';
import Heading from '@hubins/components/Heading';

const ApprovalsHubinsCompliance = () => {
  return (
    <>
      <Heading size="3" className='s-top-xl s-bottom-md'>Hubins Compliance</Heading>
      <ApprovalsByRole role="hubins_compliance" />
    </>
  );
};

export default ApprovalsHubinsCompliance;
